import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
export const Title = styled.h1.withConfig({
  displayName: "SearchTitlestyles__Title",
  componentId: "sc-133u6br-0"
})(["", ";color:", ";margin:22px 0 22px 0;line-height:35px;", "{", ";margin:16px 0;line-height:25px;}"], Fonts.medium(28), Colors.GREY_d2d2d2, Viewports.for('small'), Fonts.medium(20));
export const Count = styled.span.withConfig({
  displayName: "SearchTitlestyles__Count",
  componentId: "sc-133u6br-1"
})(["", ";padding-left:8px;", "{", ";}"], Fonts.light(28), Viewports.for('small'), Fonts.light(20));